module.exports = __webpack_public_path__ + "img/icon_location.8d8cf598.svg";